import { forwardRef, memo } from "react";
import type { ComponentPropsWithoutRef, ElementRef } from "react";
import { Card } from "antd";
import { twMerge } from "tailwind-merge";

const BASE_CLASSES = "!bg-white !rounded-xl !border-0";

export type CustomCardProps = ComponentPropsWithoutRef<typeof Card>;

const CustomCard = forwardRef<ElementRef<typeof Card>, CustomCardProps>(
  ({ className, ...props }, ref) => {
    return (
      <Card ref={ref} className={twMerge(BASE_CLASSES, className)} {...props} />
    );
  },
);

CustomCard.displayName = "CustomCard";

export default memo(CustomCard);
